import React from 'react';
import { store } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import AppRoutes from '../routes/AppRoutes';
import { Provider } from 'react-redux';

let persistor = persistStore(store);

function App() {
    return (
        <>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <AppRoutes />
                </PersistGate>
            </Provider>
        </>
    );
}

export default App;
